import {ChangeDetectionStrategy, Component, Input, OnInit} from "@angular/core";
import {SvgIconRegistryService} from "angular-svg-icon";

@Component({
    selector: 'waiting-spinner',
    templateUrl: './waiting-spinner.template.html',
    styleUrls: ['./waiting-spinner.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class WaitingSpinnerComponent implements OnInit {

	@Input() waitingText;
	@Input() visible: boolean = false;
	@Input() iconName: string = "loader-jungle-green";
	@Input() waitingTextSize: string = '14px';
	@Input() spinning: boolean = true;
	@Input() svgStyle: { [key: string]: string } = {};
	@Input() hideCaptionOnSmallScreen: boolean = false;

	constructor(private iconRegistry: SvgIconRegistryService) {
	}

	ngOnInit(): void {
		this.iconRegistry.loadSvg('assets/icons/loader-pumpkin.svg', 'loader-pumpkin');
		this.iconRegistry.loadSvg('assets/icons/loader-jungle-green.svg', 'loader-jungle-green');
		this.iconRegistry.loadSvg('assets/icons/uploaded.svg', 'uploaded');
	}
}
